<template>
	<div class="border border-secondary">
		<print-header />

		<div class="row mb-2 mt-2 mr-2 ml-2">
			<div class="col-md-4">
				<h5>Supplier Voucher</h5>
			</div>
			<div class="col-md-4 offset-md-4 text-right">
				<b>{{new moment(data.created_at).format('MMMM DD,Y HH:mm')}}</b>
			</div>
			
		</div>
		<!-- <div class="border border-secondary rounded" style="padding:20px"> -->
			<div class="row mt-2 p-3 mr-2 ml-2" style="background-color : #f2f4f5 !important;">
				<div class="col-6">
					<label style=" font-size: 16px;text-align: right !important;font-weight:bold;">Kode Voucher</label>
					<p>{{data.sv_code}} - {{data.list[0].type}}</p>
				</div>
				<div class="col-6">
					<label style=" font-size: 16px;text-align: right !important;font-weight:bold;">Nama Supplier</label>
					<p>{{data.supplier}}</p>
				</div>
				<div class="col-6">
					<label style=" font-size: 16px;text-align: right !important;font-weight:bold;">Tanggal Pembayaran</label>
					<p>{{data.payment_date ? moment(data.payment_date).format('MMM DD, YYYY') : '-'}}</p>
				</div>
				
				<div class="col-6">
					<label style=" font-size: 16px;text-align: right !important;font-weight:bold;">Nomor Referensi Pembayaran</label>
					<p>{{data.references_no ? data.references_no : '-'}}</p>
				</div>
			</div>

			<div class="mr-2 ml-2">
				<table class="table text-center mt-4 ">
					<thead class="thead-dark">
						<th>No.</th>
						<th>Work Order Code</th>
						<th>Nomor Polisi</th>
						<th>Nama</th>
						<th>Deskripsi</th>
						<th>Harga</th>
					</thead>
					<tbody v-for="(desc , index ) in detailData">
						<td>{{index + 1}}.</td>
						<td>{{desc.work_order_code ? desc.work_order_code : '-'}}</td>
						<td>{{desc.nomor_polisi ? desc.nomor_polisi : '-'}}</td>
						<td>{{desc.name}}</td>
						<td>{{desc.description}}</td>
						<td>Rp. {{numberWithCommas(desc.amount)}}</td>
					</tbody>
				</table>
			</div>
			
			<hr>
			<div class="row mt-2 p-3 mr-2 ml-2" style="background-color : #f2f4f5 !important;">
				<div class="col-md-6 text-left">
					<label style=" font-size: 16px;text-align: left !important;font-weight:bold;">Net Total</label>
				</div>
				<div class="col-md-6 text-right pr-4">
					<label style=" font-size: 16px;text-align: right !important;font-weight:bold;">
						Rp
						{{numberWithCommas(total)}}
					</label>
				</div>
				<div class="col-12" style=" font-size: 16px;text-align: right !important;font-weight:bold;"> 
					##
					{{
						Math.round(total)
							| terbilang
					}}
					Rupiah ##
				</div>
			</div>
		<!-- </div> -->
		<!-- <div class="col-6">
					<h4>Total Pengeluaran</h4>
					<p>Rp. {{numberWithCommas(total)}}</p>
				</div> -->

		<div class="row mt-5">
			<div class="offset-md-1 col-md-3 text-center">
				<h5 style="margin-bottom:85px;">Disetujui Oleh</h5>
				<hr>
				<h5>{{userData.display_name}}</h5>
			</div>
			<div class="offset-md-4 col-md-3 text-center">
				<h5 style="margin-bottom:85px;">Diterima Oleh</h5>
				<hr>
				<h5><span style="margin-right:96%;">(</span>)</h5>
				
			</div>
		</div>

	</div>
</template>

<script>
import printHeader from './../../../../../components/print/print_header.vue'
import moment from 'moment'

export default {
	props : ['detailData' , 'data', 'total'],
	components : {
		printHeader
	},
	data() {
		return {
			moment : moment,
			userData : this.$store.state.userData.userData
		}
	}
}
</script>
